module.exports = __webpack_public_path__ + "img/active-past1.7f2eaf55.jpg";